import type { CatalogueEntry } from "../types";
import imageLight from "../images/national-local-government-areas.light.webp";
import imageDark from "../images/national-local-government-areas.dark.webp";

export const entry: CatalogueEntry = {
  slug: "national-local-government-areas",
  displayName: `National Local Government Areas`,
  datasetProductCode: `GEOSCAPE LOCAL GOVERNMENT AREAS`,
  subtitle: `Spatial Mapping of Local Government Boundaries.`,
  shortDescription: `Local Government Areas is a spatial representation of the administrative divisions that local governments are responsible for across the country. A Local Government Area (LGA) will typically have an elected council as well as a council leader (e.g. mayor, shire president). Local Government Areas aggregates the representations unique to each jurisdiction into a consistent, seamless representation of the LGA boundaries across Australia.
Local Government Areas is designed to meet the needs of organisations that require a geospatial representation of LGA boundaries at both a local and national scale. The attribution provided within Local Government Areas allows for the application of the data across a wide range of commercial, government and research uses.`,
  metadata: {
    dateAdded: 1630368000000,
    dataType: ["Polygons"],
    theme: `Administrative Boundaries`,
    totalFeatureCount: 2209,
    updateFrequency: `Quarterly`,
    license: `CC BY 4.0`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/projects/lga_release/en/stable/index.html#document-index`,
  productDescriptionLink: `https://docs.geoscape.com.au/projects/lga_guide/en/stable/index.html`,
  imageLight,
  imageDark,
  searchTags: `National Local Government Areas National LGA Geoscape Local Government Areas Geoscape LGA Administrative Planning Authorities Councils Governance Boundaries Jurisdiction Analysis Local Authorities Policy Development Regions Shires`,
  detail: () =>
    import("../details/national-local-government-areas").then((m) => m.detail),
};

export default entry;
